export const Error = (error) => ({
  type: "ERROR",
  payload: error
});

export const DismissError = () => ({
    type: "DISMISS_ERROR",
  });
  